const STORAGE_KEY = "lanis_custom_lock_periods";

// Built-in Pricing / Lock Period options (in DAYS), kept in numeric order. The
// value stored on the loan IS the number of days, so add_days() computes the
// Lock Exp Date correctly. Some lenders allow specific day counts, so the LO can
// type a custom number and it's saved to their reusable list.
export const BUILT_IN_LOCK_PERIODS = [
  "7",
  "14",
  "15",
  "21",
  "30",
  "45",
  "60",
  "90"
];

function toDays(value) {
  const n = parseInt(value, 10);
  return isNaN(n) || n <= 0 ? null : n;
}

function getCustomLockPeriods() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

// Persist a new lock period (days) the LO typed, if it's a valid positive number
// not already available.
export function addCustomLockPeriod(value) {
  const n = toDays(value);
  if (n == null) return;
  const key = String(n);
  const existing = [...BUILT_IN_LOCK_PERIODS, ...getCustomLockPeriods()];
  if (existing.includes(key)) return;
  const updated = [...getCustomLockPeriods(), key];
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch {
    // localStorage unavailable
  }
}

// Built-in + custom lock periods, de-duplicated and sorted numerically.
export function getAllLockPeriods() {
  const merged = [...BUILT_IN_LOCK_PERIODS, ...getCustomLockPeriods()];
  const seen = new Set();
  const out = [];
  merged.forEach(value => {
    const n = toDays(value);
    if (n == null) return;
    const key = String(n);
    if (!seen.has(key)) {
      seen.add(key);
      out.push(key);
    }
  });
  return out.sort((a, b) => toDays(a) - toDays(b));
}
